// Converts object data and file into FormData for multipart requests
export function convertToFormData(data, file = null, fileFieldName = 'image') {
    const formData = new FormData();

    for (const key in data) {
        const value = data[key];

        if (Array.isArray(value)) {
            value.forEach(item => formData.append(`${key}[]`, item));
        } else if (value !== null && value !== undefined) {
            formData.append(key, typeof value === 'boolean' ? (value ? '1' : '0') : value);
        }
    }

    if (file) {
        formData.append(fileFieldName, file);
    }

    return formData;
}
